import AddQuestions from "../Page/AddQuestions/AddQuestions";
import AddCampaign from "../Page/Campaign/AddCampaign";
import CampaignPage from "../Page/Campaign/CampaignPage";
import CategoryDetails from "../Page/CategoryDetails/CategoryDetails";
import Categorys from "../Page/Categorys/Categorys";
import ChangePassword from "../Page/ChangePassword/ChangePassword";
import ContactInfo from "../Page/ContactInfo/ContactInfo";
import Dashboard from "../Page/Dashboard/Dashboard";
import Information from "../Page/Information/Information";
import Language from "../Page/Language/Language";
import Login from "../Page/Login/Login";
import News from "../Page/News/News";
import Offers from "../Page/Offers/Offers";
import OfferUsers from "../Page/OfferUsers/OfferUsers";
import Question from "../Page/Question/Question";
import Quiz from "../Page/Quiz/Quiz";
import SocialLink from "../Page/SocialLink/SocialLink";
import Store from "../Page/Store/Store";
import SubAdmin from "../Page/SubAdmin/SubAdmin";
import UserRole from "../Page/UserRole/UserRole";
import Users from "../Page/Users/Users";
import WebLink from "../Page/WebLink/WebLink";
import WhatsNew from "../Page/WhatsNew/WhatsNew";

export const publicRouters = [
  { path: "/", element: <Login /> },
  { path: "/login", element: <Login /> },
];

export const privateRouters = [
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/users", element: <Users /> },
  { path: "/user-role", element: <UserRole /> },
  { path: "/sub-admin", element: <SubAdmin /> },
  { path: "/brand", element: <Categorys /> },
  { path: "/contact-info", element: <ContactInfo /> },
  { path: "/brand/category-details/:id", element: <CategoryDetails /> },
  { path: "/quiz", element: <Quiz /> },
  { path: "/quiz/question/:id", element: <Question /> },
  { path: "/question/add-questions/:id", element: <AddQuestions /> },
  { path: "/web-link", element: <WebLink /> },
  { path: "/news", element: <News /> },
  { path: "/language", element: <Language /> },
  { path: "/change-password", element: <ChangePassword /> },
  { path: "/campaign", element: <CampaignPage /> },
  { path: "/add-campaign", element: <AddCampaign /> },
  { path: "/edit-campaign/:id", element: <AddCampaign /> },
  { path: "/offers", element: <Offers /> },
  { path: "/offer-user/:id", element: <OfferUsers /> },
  { path: "/store", element: <Store /> },
  { path: "/social-media", element: <SocialLink /> },
  { path: "/information", element: <Information /> },
  { path: "/whats-new", element: <WhatsNew /> },
];

export const moduleRoutes = {
  1: [{ path: "/dashboard", element: <Dashboard /> }],
  2: [{ path: "/users", element: <Users /> }],
  3: [{ path: "/user-role", element: <UserRole /> }],
  4: [
    { path: "/brand", element: <Categorys /> },
    { path: "/contact-info", element: <ContactInfo /> },
    { path: "/brand/category-details/:id", element: <CategoryDetails /> },
  ],
  5: [
    { path: "/quiz", element: <Quiz /> },
    { path: "/quiz/question/:id", element: <Question /> },
    { path: "/question/add-questions/:id", element: <AddQuestions /> },
  ],
  6: [{ path: "/web-link", element: <WebLink /> }],
  7: [{ path: "/news", element: <News /> }],
  8: [{ path: "/language", element: <Language /> }],
  9: [
    { path: "/campaign", element: <CampaignPage /> },
    { path: "/add-campaign", element: <AddCampaign /> },
    { path: "/edit-campaign/:id", element: <AddCampaign /> },
  ],
  10: [
    { path: "/offers", element: <Offers /> },
    { path: "/offer-user/:id", element: <OfferUsers /> },
  ],
  11: [{ path: "/store", element: <Store /> }],
  12: [{ path: "/social-media", element: <SocialLink /> }],
  13: [{ path: "/information", element: <Information /> }],
  14: [{ path: "/whats-new", element: <WhatsNew /> }],
};
